define(function (require) {
    "use strict";

    var BaseModel = require("models/BaseModel");
    var ApiResources = require("assets/data/apiResources.json");
    var BaseCollection = require("collections/BaseCollection");

    var PlansCollection = {};
    LE.module('LERegistration', function (LERegistration, LE, Backbone, Marionette, $, _) {
        PlansCollection = BaseCollection.extend({
            model: Backbone.Model,

            initialize: function(options) {
                this.resource = _.clone(ApiResources.Billing.BillingUpgradePlans);

                // usage and mode parsing
                this.resource = this.resource.url
                    .replace("{usage}", options.usage || 0)
                    .replace("{mode}", options.mode || PlansCollection.MODES.TRIAL);

            },

            parse: function(response, options) {
                // for test mock purposes

                /*
                 var i= 2;
                 response.push(JSON.parse(JSON.stringify(response[i])));
                 response[i].includedUnits= 42;
                 response[i].recommended= false;
                 response[i].planType= PlansCollection.TYPES.PERSONAL;       //2:is personal with data , 3: is personal without data

                 i=4;
                 response.push(JSON.parse(JSON.stringify(response[i])));
                 response[i].includedUnits= 44;
                 response[i].recommended= false;
                 response.push(JSON.parse(JSON.stringify(response[i])));
                 response[i].includedUnits= 43;
                 response[i].recommended= false;
                 */

                response= squashCatalog(response, PlansCollection.TYPES.PERSONAL);
                response= squashCatalog(response, PlansCollection.TYPES.CURRENT);
                return response;
            },

            comparator: function(plan1, plan2){
               var ret;
               var isPersonal1= plan1.get("planType") === PlansCollection.TYPES.PERSONAL;
               var isPersonal2= plan2.get("planType") === PlansCollection.TYPES.PERSONAL;

               if(isPersonal1 || isPersonal2){
                   //push PERSONAL which is not from CATALOG to beginning of collection
                   if(plan1.get("isCatalogPersonal") === false){
                       ret= -1;
                   }
                   if(plan2.get("isCatalogPersonal") === false){
                       ret= 1;
                   }
               }
               if(ret === undefined){
                   ret= plan1.get("includedUnits") - plan2.get("includedUnits");
               }

               return ret;
            }
        });
    });

    /**
     * ommits CATALOG plans from the 'plans' param that have identical
     * twins which are of type 'type'
     * @param  Array plans [description]
     * @param  const type  PlansCollection.TYPES.XXX
     */
    function squashCatalog(plans, type){
        // Incase of a typed plan remove from the collection a CATALOG clone of the plan,
        // clone as in same number of engagements and same period.
        // so there wouldn't be a case in which you show them both.
        var plan_i= _.findIndex(plans, {"planType": type});
        // if typed plan exists
        if(plan_i !== -1){
            if(type === PlansCollection.TYPES.PERSONAL){
                plans[plan_i].isCatalogPersonal= false;
            }
            var clone= _.findIndex(plans,{
                "planType": PlansCollection.TYPES.CATALOG,
                "includedUnits": plans[plan_i].includedUnits,
                "baseBillingFrequencyMonths": plans[plan_i].baseBillingFrequencyMonths
            });
            // if a catalog clone for typed plan exists
            if(clone > -1){
                if(type === PlansCollection.TYPES.PERSONAL){
                    plans[plan_i].isCatalogPersonal= true;
                }
                plans= _.reject(plans, function(plan){
                    return plan.planType == PlansCollection.TYPES.CATALOG && plan.includedUnits == plans[plan_i].includedUnits && plan.baseBillingFrequencyMonths == plans[plan_i].baseBillingFrequencyMonths;
                });
            }
        }
        return plans;
    }

    PlansCollection.MODES = {
        TRIAL: "TRIAL",
        PAYING: "PAYING"
    };

    PlansCollection.TYPES = {
        CURRENT:    "CURRENT",
        AMENDMENT:  "AMENDMENT",
        CATALOG:    "CATALOG",
        PERSONAL:   "PERSONAL"
    };
    
    return PlansCollection;
});